/**
 * Tab usability
 * This plugin adds a class to elements when they have tabfocus, which allows styling without the style applying to the :active state.
 * @version 3.0.0
 * @exports TabUsability
 */
export default class TabUsability {
    /**
     * Constructor
     * @public
     */
    constructor() {
        this.focusClass = 'usability--tab-focus';
        this._initEvents();
    }

    /**
     * Initiates events.
     * @private
     */
    _initEvents() {
        document.addEventListener('keyup', event => {
            const el = event.target;
            const tabCode = 9;

            if (event.code === tabCode && el.matches('a, button, input, textarea, select, div.carousel-cell')) {
                el.classList.add(this.focusClass);
            }

            // Menu is last element, set focus om main after menu is done tabbing.
            document.querySelector('nav#mobile-menu li:last-child a')?.addEventListener('keydown', event => {
                if (event.key === 'Tab' && !event.shiftKey) {
                    document.querySelector("#main-content").focus();
                    Window.scrollTo({ top: 0, behavior: 'auto' });
                    //$(document).scrollTop(0);
                }
            });

            // Set focus om main-header to be able to get focus on menu/logo after we tabbed through profile section elements and closed it
            const profileLinks = document.querySelectorAll('#profile-section a');
            profileLinks.length && profileLinks[profileLinks.length - 1].addEventListener('keydown', event => {
                if (event.key === 'Tab' && !event.shiftKey) {
                    document.querySelector('#profile-section').toggleAttribute('hidden', true);
                    document.querySelector('#minimize-profile').setAttribute('aria-expanded', false);
                    const header = document.querySelector('.main-header');
                    header.setAttribute('tabIndex', -1);
                    header.focus();
                }
            });
        });

        document.addEventListener('click', event => {
            if (event.target.matches('input, textarea')) {
                event.target.classList.add(this.focusClass);
            }
        });

        document.addEventListener('blur', event => event.target.classList?.remove(this.focusClass), true);
    }
}
